export const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const REACT_APP_FRONT_URL = process.env.REACT_APP_FRONT_URL;

export const buildUrl = (path) => {
    return `${REACT_APP_BACKEND_URL}${path}`
};